import React from 'react';

import { Form, Input } from 'antd';
import { Button, ButtonType, Column, Row } from 'farmhub-ui-core';

import { theme } from 'styled';

import SelectColor from './SelectColor';
import { PartnerNoteEditorWrapper } from './styles';

const { TextArea } = Input;

type PartnerNoteEditorProps = {
  title: string;
  color?: string;
  onSubmit: (val: any) => Promise<void>;
  onCancel: () => void;
};

const PartnerNoteEditor = ({
  title,
  color,
  onSubmit,
  onCancel,
}: PartnerNoteEditorProps): JSX.Element => {
  const [isLoading, setIsLoading] = React.useState(false);
  const [chooseColor, setChooseColor] = React.useState<string | undefined>(
    undefined
  );
  const [form] = Form.useForm();

  const handleCancel = () => {
    onCancel();
    handleClearData();
  };

  const handleClearData = () => {
    form.setFieldsValue({ title: '' });
    setChooseColor(undefined);
  };

  const handleSubmit = () => {
    form.validateFields().then(async (values: any) => {
      setIsLoading(true);
      await onSubmit({
        color: chooseColor || 'red',
        title: values.title,
      });

      handleClearData();
      setIsLoading(false);
    });
  };

  React.useEffect(() => {
    if (color && title.length > 0) {
      form.setFieldsValue({ title });
      setChooseColor(color);
    }
  }, [title, color]);

  return (
    <PartnerNoteEditorWrapper>
      <Row
        alignItems="flex-start"
        styles={{ marginTop: 2 }}
        width="fit-content"
      >
        <SelectColor color={chooseColor} setColor={setChooseColor} />
      </Row>
      <Form form={form} style={{ width: '100%' }}>
        <Column styles={{ gap: 12 }}>
          <Form.Item
            name="title"
            rules={[
              {
                required: true,
                message: 'Vui lòng nhập tiêu đề!',
              },
            ]}
            style={{ width: '100%' }}
          >
            <TextArea autoFocus placeholder="Nhập tiêu đề ghi chú" rows={1} />
          </Form.Item>
          <Row styles={{ gap: 6 }}>
            <Button
              height={theme.button.height.xs}
              loading={isLoading}
              weight="50px"
              onClick={handleSubmit}
            >
              Lưu
            </Button>
            <Button
              height={theme.button.height.xs}
              type={ButtonType.Ghost}
              weight="50px"
              onClick={handleCancel}
            >
              Hủy
            </Button>
          </Row>
        </Column>
      </Form>
    </PartnerNoteEditorWrapper>
  );
};

export default PartnerNoteEditor;
